import React, { ReactNode } from "react";

import { Container } from "@gamedev-web/gamedev-sdk-core";

import * as styles from "./RightPaneBox.module.css";

export type RightPaneBoxProps = Readonly<{
  children?: ReactNode;
  customClassName?: string;
}>;

export const RightPaneBox = ({ children, customClassName }: RightPaneBoxProps) => (
  <Container className={customClassName ?? styles.rightPaneBox}>{children}</Container>
);
